import './LoginBtn.css';
import React, { useEffect, useState, useContext } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { IconToggleArrowDown } from '../../components/atoms/Icons';
import { ReactComponent as Logout } from '../../resources/icons/logout.svg';
import { getUserCookie, logoutUser } from '../Login/user_session';
// import { Link } from 'react-router-dom';
// import { RouterLink as Link } from 'react-router-dom';
import RouterLink from '../atoms/RouterLink';
import { canUseDOM, isChina } from '../../utils';
import { get, getDictionaryItem } from '../../utils';
const LoginBtn = _ref => {
  let {
    accountLinks,
    dictionary,
    analyticsClick,
    closeNav,
    isMobileView,
    userProfile
  } = _ref;
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const lang = sitecoreContext && sitecoreContext.language;
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  const [loginState, setLoginState] = useState(false);
  const [mobOpenState, setMobOpenState] = useState(false);
  const [userName, setUserName] = useState('');
  const linksArray = get(accountLinks, 'targetItem.links');
  // const dictionaryArray = get(dictionary, 'targetItem.links');
  const editProfile = linksArray && linksArray[0];
  const Login = linksArray && linksArray[2];

  /* const eventCalendar = linksArray && linksArray[1]; */
  const myAccount = linksArray && linksArray[3];
  const ticketPurchase = linksArray && linksArray[5];
  const topPicks = linksArray && linksArray[6];
  // const dictionaryValues: any = { dictionaryValues: [...dictionary] };
  const logoutCopy = getDictionaryItem(dictionary && dictionary.dictionary, 'Logout');
  const loginHref = get(Login, 'link.jss.value.href');
  const [usernameArabic, setUsernamearabic] = useState(false);
  useEffect(() => {
    let user = '';
    if (userProfile) {
      const {
        firstName,
        lastName,
        email
      } = userProfile;
      if (firstName && firstName.length || lastName && lastName.length) {
        user = `${firstName ? firstName + ' ' : ''}${lastName ? lastName : ''}`;
      } else {
        user = `${email ? email : ''}`;
      }
      if (isArabic(user)) {
        setUsernamearabic(true);
      }
      setUserName(user);
      setLoginState(true);
    }
  }, [userProfile]);
  const isArabic = text => {
    let arabic = /[\u0600-\u06FF]/;
    let result = arabic.test(text);
    return result;
  };
  if (!loginHref) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, !isChina() ? /*#__PURE__*/React.createElement("div", {
    className: `login-element-wrapper ${loginState ? 'login-element-wrapper--logged-in' : ''}`
  }, loginState ? /*#__PURE__*/React.createElement("span", {
    className: `header-tr__link--logged-in header-tr__link header-tr__link-login ${mobOpenState ? 'header-tr__link-login--open' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-tr__link-inner",
    onClick: () => {
      setMobOpenState(!mobOpenState);
      if (analyticsClick) {
        analyticsClick();
      }
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: get(Login, 'icon.jss.value.src'),
    className: "login-icon ",
    alt: get(Login, 'title.jss.value')
  }), /*#__PURE__*/React.createElement("span", {
    className: `username ${usernameArabic ? 'username--arabic' : ''}`,
    dir: "auto"
  }, userName), /*#__PURE__*/React.createElement("span", {
    className: "nav-link__arrow"
  }, /*#__PURE__*/React.createElement(IconToggleArrowDown, null))), /*#__PURE__*/React.createElement("div", {
    className: "login__dropdown"
  }, get(topPicks, 'link.jss.value.href') && /*#__PURE__*/React.createElement("div", {
    className: "login__dropdown-item"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "login__dropdown-link",
    href: get(topPicks, 'link.jss.value.href')
  }, /*#__PURE__*/React.createElement("span", {
    className: "login__dropdown-icon"
  }, /*#__PURE__*/React.createElement("img", {
    src: get(topPicks, 'icon.jss.value.src'),
    alt: get(topPicks, 'title.jss.value')
  })), get(topPicks, 'title.jss.value'))), get(ticketPurchase, 'link.jss.value.href') && /*#__PURE__*/React.createElement("div", {
    className: "login__dropdown-item"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "login__dropdown-link",
    href: get(ticketPurchase, 'link.jss.value.href'),
    onClick: () => {
      if (closeNav && typeof closeNav === "function") {
        closeNav();
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "login__dropdown-icon"
  }, /*#__PURE__*/React.createElement("img", {
    src: get(ticketPurchase, 'icon.jss.value.src'),
    alt: get(ticketPurchase, 'title.jss.value')
  })), get(ticketPurchase, 'title.jss.value'))), get(myAccount, 'title.jss.value') && /*#__PURE__*/React.createElement("div", {
    className: "login__dropdown-item"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "login__dropdown-link",
    href: get(myAccount, 'link.jss.value.href'),
    onClick: () => {
      if (closeNav && typeof closeNav === "function") {
        closeNav();
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "login__dropdown-icon"
  }, /*#__PURE__*/React.createElement("img", {
    src: get(myAccount, 'icon.jss.value.src'),
    alt: get(myAccount, 'title.jss.value')
  })), get(myAccount, 'title.jss.value'))), get(editProfile, 'title.jss.value') && /*#__PURE__*/React.createElement("div", {
    className: "login__dropdown-item"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "login__dropdown-link",
    href: get(editProfile, 'link.jss.value.href'),
    onClick: () => {
      if (closeNav && typeof closeNav === "function") {
        closeNav();
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "login__dropdown-icon"
  }, /*#__PURE__*/React.createElement("img", {
    src: get(editProfile, 'icon.jss.value.src'),
    alt: get(editProfile, 'title.jss.value')
  })), get(editProfile, 'title.jss.value'))), /*#__PURE__*/React.createElement("div", {
    className: "login__dropdown-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "login__dropdown-link",
    onClick: () => {
      if (canUseDOM) {
        const cookie = getUserCookie();
        if (cookie.login_status) {
          logoutUser(identityGlobal, clientId, clientSecret).then(response => {
            if (response) {
              window.location.href = `${lang ? `/${lang}` : '/'}`;
            }
          });
        } else {
          window.location.href = `${lang ? `/${lang}` : '/'}`;
        }
        if (closeNav && typeof closeNav === "function") {
          closeNav();
        }
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "login__dropdown-icon"
  }, /*#__PURE__*/React.createElement(Logout, null)), logoutCopy)))) : /*#__PURE__*/React.createElement("a", {
    className: "header-tr__link header-tr__link-login header-tr__link-inner",
    href: loginHref,
    onClick: () => {
      if (closeNav && typeof closeNav === "function") {
        closeNav();
      }
      if (analyticsClick) {
        analyticsClick();
      }
    },
    "aria-label": get(Login, 'title.jss.value')
  }, /*#__PURE__*/React.createElement("img", {
    src: get(Login, 'icon.jss.value.src'),
    className: "login-icon rs_skip",
    alt: `${isMobileView ? 'mobile ' + get(Login, 'title.jss.value') : get(Login, 'title.jss.value') + ` ${Math.random().toFixed(2)}`}`
  }), get(Login, 'title.jss.value'))) : null);
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${rtl ? rtlStyles : ltrStyles} ${commonStyles}`
  }, children);
};
const commonStyles = "cbtx3uf";
const ltrStyles = "ll3unz8";
const rtlStyles = "r1ek9o2u";
export default LoginBtn;